// extracted by mini-css-extract-plugin
export default {"parent":"rated_parent__4rbRP"};